import React from "react";
import { useNavigate } from "react-router-dom";
import "./TrackOrder.css";
import UserInfo from "./UserInfo/UserInfo";
import Delivery_Partner from "./delivery_partner/Delivery_Partner";
import Payment_Summary from "../MyAccount/Account/my_account_tabs/my_orders/order_details/payment_summary/Payment_Summary";
import Green_Btn from "../Common-Component/common_btn/green_btn/Green_Btn";
import Order_details_table from "../MyAccount/Account/my_account_tabs/my_orders/order_details/order_details_table/Order_details_table";
import Estimate_Time_Component from "./Estimate_Time_Component/Estimate_Time_Component";

const TrackOrder = () => {
  const navigate = useNavigate();

  return (
    <section className="TrackOrder">
      {/* <Top_Heading /> */}

      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <UserInfo />
            <div className="table_div">
              <Order_details_table dontShowPrice={true} />
            </div>
            <div className="btn_holder">
              <Green_Btn
                btn_name="Go to Home"
                onClick={() => {
                  navigate("/");
                }}
              />
            </div>
          </div>
          <div className="col-lg-4">
            <Estimate_Time_Component />
            <Delivery_Partner />
            <Payment_Summary />
          </div>
        </div>
      </div>

      {/* <OrderInfo callText={"Call Store"} />
                <UserInfo />
                <Orderetails /> */}
    </section>
  );
};

export default TrackOrder;
